import styled from '@emotion/styled'
import { css } from 'emotion'
import Button from '../Button'


export const StyledButtonBarBtn = styled(Button)`
  margin-right: 0;
  margin-top: 0;
`